import React from "react";
import { Customer, ILeadActivity } from "../../../../core";
import { ActivityItem } from "./activity-item";
import { ChangeLogItem } from "./change-log-item";
import { FileItem } from "./file-item";
import { NoteItem } from "./note-item";

export class ActivityItemBuilder {
  static builder: {
    [type: string]: (
      activity: ILeadActivity,
      leadId?: string,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {};
  } = {
    changeLog: (activity: ILeadActivity, leadId, onPressEdit?: () => void) => {
      return <ChangeLogItem activity={activity} />;
    },
    note: (activity: ILeadActivity, leadId, onPressEdit?: () => void) => {
      return <NoteItem activity={activity} />;
    },
    file: (activity: ILeadActivity, leadId, onPressEdit?: () => void) => {
      return <FileItem activity={activity} />;
    },
    call: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          onReload={onReload}
        />
      );
    },
    meeting: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          onReload={onReload}
        />
      );
    },
    deadline: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          onReload={onReload}
        />
      );
    },
    task: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          onReload={onReload}
        />
      );
    },
    requestACallBack: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          onReload={onReload}
          
        />
      );
    },
    scheduleATestDrive: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          customer={customer}
          onUpdateCustomer={onUpdateCustomer}
          onReload={onReload}
        />
      );
    },
    activity: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          onReload={onReload}
        />
      );
    },
    showroomAppointment: (
      activity: ILeadActivity,
      leadId,
      onPressEdit?: () => void,
      customer?: Customer,
      onUpdateCustomer?: (id: string) => void,
      onReload?: () => void
    ) => {
      return (
        <ActivityItem
          onPressEdit={onPressEdit}
          leadId={leadId}
          activity={activity}
          customer={customer}
          onUpdateCustomer={onUpdateCustomer}
          onReload={onReload}
        />
      );
    },
  };
}
